import axios from 'axios'

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:8001',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  }
})

function getToken() {
  try {
    const raw = localStorage.getItem('rematei-auth')
    if (!raw) return null
    return JSON.parse(raw)?.state?.token || null
  } catch {
    return null
  }
}

function saveToken(token) {
  try {
    const raw = localStorage.getItem('rematei-auth')
    const auth = raw ? JSON.parse(raw) : { state: {} }
    auth.state.token = token
    localStorage.setItem('rematei-auth', JSON.stringify(auth))
    localStorage.setItem('token', token)
  } catch { /* ignore */ }
}

// Request interceptor — injeta o token em toda requisição
api.interceptors.request.use(
  (config) => {
    const token = getToken()
    if (token) config.headers.Authorization = `Bearer ${token}`
    return config
  },
  (error) => Promise.reject(error)
)

// Flag para evitar múltiplos refreshes simultâneos
let _refreshing = false
let _waitingQueue = []

function processQueue(error, token = null) {
  _waitingQueue.forEach(({ resolve, reject }) =>
    error ? reject(error) : resolve(token)
  )
  _waitingQueue = []
}

// Response interceptor — tenta refresh antes de redirecionar pro login
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config

    if (error.response?.status !== 401 || original._retry) {
      return Promise.reject(error)
    }

    // Não tenta refresh na própria rota de login/refresh
    if (original.url?.includes('/auth/')) {
      localStorage.removeItem('rematei-auth')
      localStorage.removeItem('token')
      window.location.href = '/login'
      return Promise.reject(error)
    }

    if (_refreshing) {
      // Aguarda o refresh em andamento terminar
      return new Promise((resolve, reject) => {
        _waitingQueue.push({ resolve, reject })
      }).then((token) => {
        original.headers.Authorization = `Bearer ${token}`
        return api(original)
      })
    }

    original._retry = true
    _refreshing = true

    try {
      const response = await axios.post(
        `${import.meta.env.VITE_API_URL || 'http://localhost:8001'}auth/refresh`,
        {},
        { headers: { Authorization: `Bearer ${getToken()}` } }
      )
      const newToken = response.data.access_token
      saveToken(newToken)
      processQueue(null, newToken)
      original.headers.Authorization = `Bearer ${newToken}`
      return api(original)
    } catch (refreshError) {
      processQueue(refreshError, null)
      localStorage.removeItem('rematei-auth')
      localStorage.removeItem('token')
      window.location.href = '/login'
      return Promise.reject(refreshError)
    } finally {
      _refreshing = false
    }
  }
)

export default api
